import { Activity, TrendingUp, FileText, ClipboardList, AlertTriangle, History, FlaskConical } from 'lucide-react';
import { SectionTabs } from '@/components/shared/SectionTabs';

/**
 * Système d'onglets pour la navigation dans le détail patient
 * Utilisé par NursePatientDetail et DoctorPatientDetail
 */

const DEFAULT_TABS = [
  { id: "overview", label: "Vue d'ensemble", icon: Activity },
  { id: "graphs", label: "Graphiques", icon: TrendingUp },
  { id: "history", label: "Historique", icon: History },
  { id: "studies", label: "Études", icon: FlaskConical },
  { id: "dossier", label: "Dossier médical", icon: FileText },
  { id: "checkins", label: "Check-ins", icon: ClipboardList },
  { id: "alerts", label: "Alertes", icon: AlertTriangle },
];

export default function PatientDetailTabs({ 
  activeTab, 
  onTabChange, 
  checkinsCount = 0, 
  alertsCount = 0,
  tabs = DEFAULT_TABS 
}) {
  const tabsWithCounts = tabs.map(tab => {
    if (tab.id === "checkins" && checkinsCount > 0) return { ...tab, count: checkinsCount };
    if (tab.id === "alerts" && alertsCount > 0) return { ...tab, count: alertsCount };
    return tab;
  });

  return <SectionTabs tabs={tabsWithCounts} active={activeTab} onChange={onTabChange} />;
}
